import React from 'react';

const Logo = () => (
  <img
    src="https://assets.getsquire.com/widget-release-email/logo.png"
    srcSet="https://assets.getsquire.com/widget-release-email/logo@2x.png 2x"
    role="presentation"
    alt="Squire"
    title="Squire logo"
    className="c-vi-logo"
  />
);

export default Logo;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/Logo.jsx